/**
 * Lit une réponse fetch de façon défensive.
 * L'API ColdFusion peut renvoyer un corps vide ou du HTML d'erreur ;
 * response.json() lève alors une exception illisible pour l'utilisateur.
 *
 * @param {Response} response
 * @returns {Promise<{ok: boolean, data: object|null, error: string|null}>}
 */
export const parseJsonResponse = async (response) => {
    let text = '';

    try {
        text = await response.text();
    } catch {
        return { ok: false, data: null, error: 'Réponse du serveur illisible.' };
    }

    if (!text || !text.trim()) {
        return {
            ok: false,
            data: null,
            error: 'Le serveur a renvoyé une réponse vide. L\'opération a peut-être abouti : vérifiez avant de recommencer.'
        };
    }

    let data = null;
    try {
        data = JSON.parse(text);
    } catch {
        return {
            ok: false,
            data: null,
            error: 'Réponse inattendue du serveur (format non reconnu).'
        };
    }

    if (!response.ok) {
        let message = `Erreur ${response.status}`;
        if (data && (data.message || data.MESSAGE)) {
            message = data.message || data.MESSAGE;
        }
        return { ok: false, data, error: message };
    }

    return { ok: true, data, error: null };
};
